import { Directive, HostListener, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { LoggingService } from '@fgb/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, of } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';

@Directive({
  selector: '[fgbWebsiteContentFeatureFlag]',
})

/**
 * This directive is used to hide features
 * throughout the portal depending on the
 * given feature flag set within website content.
 *
 * Example of usage:
 * <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.member.card'"> ... </ng-container>
 */
export class WebsiteContentFeatureFlagDirective implements OnInit {
  @Input('fgbWebsiteContentFeatureFlag') featureKey: string | undefined;
  private _isDestroyed$ = new Subject<void>();

  constructor(
    private translate: TranslateService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private log: LoggingService
  ) {}

  ngOnInit() {
    this.isFeatureEnabled(this.featureKey)
      .pipe(takeUntil(this._isDestroyed$))
      .subscribe((result) => {
        if (result) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      });
  }

  private isFeatureEnabled(featureKey: string | undefined) {
    if (!featureKey) {
      this.log.debug('[WSCFeatureFlagDirective] No feature key provided');
      return of(false);
    }

    return this.translate.stream(featureKey).pipe(
      tap((data) => {
        this.log.debug(`[WSCFeatureFlagDirective] Checking feature is actviated for "${featureKey}" has value "${data}"`);
      }),
      map((data) => data === 'true')
    );
  }

  @HostListener('window:beforeunload')
  ngOnDestroy() {
    this._isDestroyed$.next();
    this._isDestroyed$.complete();
  }
}
